import React, { useState } from 'react';
import {HashLink as NavLink} from 'react-router-hash-link'
import './Navbar.css'
import Logo from '../../Logo/Logo';
const Navbar = () => {
    const [click, setClick] = useState(false);
    const handleClick = () => {
        setClick(!click);
    }
    const closeMobileMenu = () => {
        setClick(false);
    }
    
    return (
        <>
            <nav className="navbar">
                <NavLink to="/" className="logo-div"><span><Logo/></span><span>Nabil Woalid Rafiu</span> </NavLink>

                 <div className="menu-icon" onClick={handleClick}>
                    {
                        click ? <i class="fas fa-times"></i> : <i class="fas fa-bars"></i>
                    }
                </div>
                <ul onClick={closeMobileMenu} className={click ? 'nav-links active' : 'nav-links'}>
                    <li  className="nav-item">
                        <NavLink className="nav-link" activeClassName="nav-link-active" smooth to="/#about">About Me </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink smooth className="nav-link" activeClassName="nav-link-active" to="#services">Services </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link" activeClassName="nav-link-active" smooth to="#project">Projects </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link" activeClassName="nav-link-active" smooth to="#contact">Contact </NavLink>
                    </li>
                    <li className="nav-item">
                    <a className="resume-link" href="https://drive.google.com/uc?export=download&id=19f_GCqmVr2QJ09h0FT7a5S2oew6u1_5D" target="_blank" rel="noreferrer">
                    <button className="main-btn">
                 Resume
               </button>
                </a>
                    </li>
                   
                </ul>
            </nav>
        </>
    );
};

export default Navbar;